import { css } from '@emotion/core';
import { tokens, applyFont, media } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  typography = tokens.typography;
export var articleCard = /*#__PURE__*/css("flex-grow:1;flex-direction:column;display:flex;width:100%;border-radius:3px;overflow:hidden;min-height:124px;align-items:stretch;background:", colors.neutral.subdued.default, ";&:hover .title{color:", colors.neutral.heavy.hover, ";}");
export var link = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";text-decoration:none;");
export var content = {
  name: "1y2exxf",
  styles: "display:flex;justify-content:space-between;align-items:stretch;flex-grow:1;"
};
export var topImageContainer = {
  name: "1nq2tkm",
  styles: "display:block;height:200px;width:auto;img{width:100%;height:100%;object-fit:cover;}"
};
export var leftImageContainer = {
  name: "1cvgktt",
  styles: "display:block;max-width:339px;max-height:300px;img{width:100%;min-width:339px;height:100%;object-fit:cover;}"
};
export var middle = /*#__PURE__*/css("display:flex;flex-direction:column;flex-grow:1;padding:16px;justify-content:space-between;gap:16px;", media('>=tablet'), "{padding:32px;}");
export var heading = /*#__PURE__*/css(applyFont(typography.heading), " color:", colors.neutral.heavy.default, ";", truncateLines(4), " text-decoration:none;");
export var authorDate = /*#__PURE__*/css("display:flex;flex-direction:row;color:", colors.neutral.medium.default, ";gap:8px;");
export var author = /*#__PURE__*/css(applyFont(typography.captionBold), " border-right:1px solid ", colors.neutral.trim.default, ";padding-right:8px;");
export var date = /*#__PURE__*/css(applyFont(typography.caption));
var bodyLongLineHeight = 24;
export var description = _ref => {
  var fixedHeight = _ref.fixedHeight,
    maxLines = _ref.maxLines;
  return /*#__PURE__*/css(truncateLines(maxLines), " ", applyFont(typography.body), " line-height:", bodyLongLineHeight, "px;color:", colors.neutral.heavy.default, ";", fixedHeight && /*#__PURE__*/css("height:", maxLines * bodyLongLineHeight, "px;"));
};